import { DataDRequest } from "../DRequest"
import { PromiseRequest } from "./PromiseRequest"

import IRequestResponseListA = DataDRequest.IRequestResponseListA

type PromiseResponseList<ItemResultList> = PromiseRequest<DataDRequest.IRequestResponseListA<ItemResultList>>
export interface DataRequestWKListConfig<ItemIterable, ItemResultList> {
    iterable: ItemIterable[]
    individualRequest: (itemIterable: ItemIterable)
        => (() => PromiseResponseList<ItemResultList>) | Promise<(() => PromiseResponseList<ItemResultList>)>
}

export class DataRequestWKList<ItemIterable, ItemResultList> {
    private interrupted = false
    private config: DataRequestWKListConfig<ItemIterable, ItemResultList>
    private promise: Promise<IRequestResponseListA<ItemResultList>[]>
    private currentReq: PromiseRequest<DataDRequest.IRequestResponseListA<ItemResultList>>

    constructor(config: DataRequestWKListConfig<ItemIterable, ItemResultList>) {
        this.config = config
        this.DoRequests()
    }

    private DoRequests() {
        if (this.promise) return

        this.promise = new Promise(async (resolve) => {
            const resultList: IRequestResponseListA<ItemResultList>[] = []
            if (this.interrupted) {
                resolve(resultList)
                return
            }

            const { iterable, individualRequest } = this.config
            for (const item of iterable) {
                if (this.interrupted) {
                    // console.warn("interrupted", iterable.length - resultList.length, "items")
                    resolve(resultList)
                    return
                }

                this.currentReq = null

                let stepReqFn = individualRequest(item)
                const valideFunction = () => {
                    if (typeof stepReqFn != "function") return null
                    const stepReq: PromiseRequest<DataDRequest.IRequestResponseListA<ItemResultList>> = stepReqFn()
                    if (stepReq instanceof PromiseRequest) {
                        this.currentReq = stepReq
                    }
                }

                valideFunction()
                if (!this.currentReq && stepReqFn instanceof Promise) {
                    stepReqFn = await stepReqFn
                    valideFunction()
                }

                if (!this.currentReq) {
                    console.error("individualRequest invalid result!!!")
                    continue
                }

                const resList = await this.currentReq

                if (resList.Resultado != DataDRequest.__RESCODE_ABORTED) {
                    // console.warn("resList", resList)
                    resultList.push(resList)
                }
                // else console.warn("aborted", 1, "item")
            }

            resolve(resultList)
        })
    }

    public get _Promise() {
        return this.promise
    }

    public _Interrupt() {
        this.interrupted = true
        if (this.currentReq instanceof PromiseRequest) {
            this.currentReq._Abort()
        }
    }
}